import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'react-bootstrap'
import './Banner.module.scss'

const propTypes = {
  /**
   * Message for banner.
   */
  message: PropTypes.node,
  /**
   * Button text for banner.
   */
  buttonText: PropTypes.node,
  /**
   * Button callback for banner.
   */
  onPress: PropTypes.func.isRequired,
  /**
   * show screen in read only mode
   */
  readOnly: PropTypes.bool,
}

function Banner(props) {
  const { buttonText = '', message = '', onPress, readOnly = false } = props ?? {}
  return (
    <div className={clsx('Uic-Banner-base')}>
      <div>
        <i className={clsx('fas fa-triangle-exclamation', 'Uic-Banner-icon')} />
        <span className={clsx('Uic-Banner-msg_text')}>{message}</span>
      </div>
      <Button disabled={readOnly} onClick={() => onPress()} className={clsx('Uic-Banner-button_view')}>
        {buttonText}
      </Button>
    </div>
  )
}

Banner.propTypes = propTypes

export default Banner
